import { useState } from 'react';
import { useSelector } from 'react-redux';

import { hasValue } from 'utils/hasValue';

import { useGetCustomerUsersUserId } from 'api';

import { selectUserId } from 'reduxLocal/slices/authSlice';

import { useOrganisationId } from 'hooks/context';

import { Loading } from 'components/pages/Loading';

import { UserProfileEdit } from './UserProfileEdit';
import { UserProfileShow } from './UserProfileShow';

export const UserProfile = () => {
  const userId = useSelector(selectUserId);
  const organisationId = useOrganisationId<number>();

  const [isEdit, setIsEdit] = useState(false);

  const {
    data: { data: user } = {},
    isLoading,
    isError,
    isSuccess,
    refetch
  } = useGetCustomerUsersUserId(organisationId, Number(userId));

  const onEditClick = () => setIsEdit(true);
  const onFormClose = () => setIsEdit(false);
  const onFormSuccess = () => {
    refetch();
    setIsEdit(false);
  };

  if (!userId) return null;

  return (
    <div
      role="complementary"
      aria-label="User Profile"
      className="h-full px-4 py-8"
    >
      <div className="flex max-h-full w-full flex-col overflow-hidden rounded-2xl bg-white shadow-plain-lg">
        <div>
          <div className="flex items-center justify-between border-b px-6 py-3.5 text-xl font-semibold">
            <header>{isEdit ? 'Edit Profile' : 'User Profile'}</header>
          </div>
        </div>
        <div className="overflow-auto">
          {isLoading && <Loading />}
          {isSuccess && hasValue(user) && (
            <>
              {!isEdit ? (
                <UserProfileShow data={user} onEditClick={onEditClick} />
              ) : (
                <UserProfileEdit
                  data={user}
                  onCancelClick={onFormClose}
                  onSuccess={onFormSuccess}
                />
              )}
            </>
          )}
          {isError && (
            <div className="flex h-full items-center justify-center">
              Something went wrong
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
